"use client";

import Sticky from "react-stickynode";

// Exporting the Sticky component to be used elsewhere in your project to avoid error of client/server component
export default Sticky;
